import React, { forwardRef, useEffect, useImperativeHandle, useState } from "react";
import { ExportViewProps, ExportViewRef } from "./models";
import SearchFilter, { Filters } from "../../../Common/SearchFilter/SearchFilter";
import { searchFilterToExportExcelFilter } from "../../../Common/SearchFilter/utils";
import useDidMountEffect from "../../../Common/UseDidMountEffect";
import { ApiBackend } from "../../../../providers/apibackend";
import { Event } from "../../../../model/Event";

type SearchFilterType = {
    raceWeek?: string;
};

interface ISearchFilter {
    raceWeek?: string;
}

const OnSiteHoodies = forwardRef<ExportViewRef, ExportViewProps>((props, ref) => {
    const [searchFilter, setSearchFilter] = useState(null as ISearchFilter);
    const [events, setEvents] = useState(null as Event[]);

    useImperativeHandle(ref, () => ({
        isValid: () => {
            return !!searchFilter?.raceWeek;
        }
    }));

    useEffect(() => {
        new ApiBackend().listEvents().then((res) => {
            setEvents(res);
        });
    }, []);

    useDidMountEffect(() => {
        props.onChange(searchFilterToExportExcelFilter<ISearchFilter>(searchFilter));
    }, [searchFilter]);

    const render = () => {
        return (
            <SearchFilter<SearchFilterType>
                id={"export-onsitehoodies-filter"}
                filters={{
                    "raceWeek": {
                        id: "filter-raceWeek",
                        type: "GenericSelect",
                        label: "Evenemang",
                        size: 12,
                        multiple: false,
                        itemDefinition: {
                            items: events == null ? [] : events.map(x => { return { name: x.name, value: x.id } }),
                            itemValueType: "string"
                        }
                    },
                }}
                persist={true}
                onInit={(filter: Filters<SearchFilterType>) => {
                    setSearchFilter(filter as unknown as ISearchFilter);
                }}
                onChange={(filter: Filters<SearchFilterType>) => {
                    setSearchFilter(filter as unknown as ISearchFilter);
                }}
            />
        );
    };

    return render();
});

export default OnSiteHoodies;
